module.exports = __webpack_public_path__ + "static/media/logo-televisa.627e0d41.svg";